// caseListSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { getCaseListCards, getSavedSearches } from './caseListThunk';

interface CaseListState {
    data: {
        count_open_cases: number,
        count_serious_cases: number,
        count_due_cases: number
    };
    savedSearchList: any;
    loading: boolean;
    error: string | null;
}

const initialState: CaseListState = {
    data: {
        count_open_cases: 0,
        count_serious_cases: 0,
        count_due_cases: 0
    },
    savedSearchList: {},
    loading: false,
    error: null,
};

const caseListSlice = createSlice({
    name: 'caseList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCaseListCards.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCaseListCards.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getCaseListCards.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
        builder
            .addCase(getSavedSearches.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSavedSearches.fulfilled, (state, action) => {
                state.loading = false;
                state.savedSearchList = action.payload;
            })
            .addCase(getSavedSearches.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default caseListSlice.reducer;
